import SectionContent from "./SectionContent";
import SectionHeroComponent from "./SectionHero";
export default SectionContent;
export const SectionHero = SectionHeroComponent;
